module.exports = __webpack_public_path__ + "img/Capture4.d5a289db.jpg";